import { Storage } from "@ionic/storage";
import { defineStore } from "pinia";
import { de, enGB } from "date-fns/locale";
import Translator from "@/plugins/Translator";
import { LanguageStoreState } from "@/types/Stores/LanguageStoreState";

export const useLanguageStore = defineStore({
	id: "languageStore",
	state: () =>
		({
			activeLanguage: "",
			activeLocale: de,
			/*----- persistent storage -----*/
			storage: new Storage({ storeName: "languageStore" }),
		} as LanguageStoreState),
	actions: {
		async init() {
			await this.storage.create();
			this.activeLanguage = await this.getLanguageFromStorage();
			await this.setActiveLocale(this.activeLanguage);
			if (this.activeLanguage == null || this.activeLocale == null) {
				await this.setLanguage("de");
			}
		},
		getLanguage(): string {
			return this.activeLanguage;
		},
		async getLanguageFromStorage() {
			return await this.storage.get("language");
		},
		setActiveLocale(language: string) {
			switch (language) {
				case "de":
					this.activeLocale = de;
					break;
				case "en":
					this.activeLocale = enGB;
					break;
				default:
					this.activeLocale = de;
			}
		},
		getLocale(): Locale {
			return this.activeLocale;
		},
		async setLanguage(language: string) {
			this.activeLanguage = language;
			this.setActiveLocale(this.activeLanguage);
			const translator = Translator.getInstance();
			translator.setLanguage(this.activeLanguage);
			await this.storage.set("language", this.activeLanguage);
		},
	},
});
